import View from "../common/views/SearchProductFnacPlusView";
import components from "./components.js";
components.define("js-searchFnacPlus", View);